import { Component, inject, OnInit } from '@angular/core';
import { AnalyticsService } from './core/services/analytics/analytics.service';
import { BootupService } from './core/services/bootup/bootup.service';
import { JobService } from './core/services/job/job.service';
import { Job } from './core/services/job/job';
import { AuthService } from './core/services/auth/auth.service';
import { ThemeService } from './core/services/theme/theme.service';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  private analyticsService = inject(AnalyticsService);
  private bootupService = inject(BootupService);
  private jobService = inject(JobService);
  private authService = inject(AuthService);
  private themeService = inject(ThemeService);

  async ngOnInit(): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);
    const sparketUserId = this.getUrlParam('playerId', urlParams);
    const sparketUsername = this.getUrlParam('playerUsername', urlParams);
    const loginToken = this.getUrlParam('loginToken', urlParams);

    setTimeout(() => {
      // Place this in a timeout so it doesn't get called too early, we need this to happen as
      // soon as possible
      this.themeService.initialise();
    });

    this.analyticsService.signIn(sparketUserId, 'sparket');
    this.authService.initialise(sparketUserId, sparketUsername, loginToken);

    const job = this.jobService.create(async () => {
      await this.bootupService.initialise();
    });
    job.showNoInternetRetry(Job.InfiniteRetry);
    job.addErrorHandler().showFatalError().reloadWindow();
    await job.runNoThrow();
  }

  private getUrlParam(key: string, urlParams: URLSearchParams): string {
    const value = urlParams.get(key) ?? '';
    if (!urlParams.has(key) || value.length === 0) {
      console.error(`Url parameter '${key}' missing or empty`);
      this.analyticsService.logBreadcrumb('Missing url param', { key });
    }
    return value;
  }
}
